import { Autocomplete, AutocompleteProps, TextField } from "@mui/material";
import { GoodInventoryItem } from "../../../../../graphql/generated";
import { ConditionValueSelectorComponentProps } from "../../ConditionForm";
import { castArray } from "lodash";
import { testIds } from "./GoodsInput.testIds";

const GoodsInput = ({
  value: valueProp,
  onChange,
  goods: goodInventoryItems,
  ...otherProps
}: ConditionValueSelectorComponentProps & {
  goods: Pick<GoodInventoryItem, "_id" | "label">[];
} & Pick<AutocompleteProps<string, true, undefined, undefined>, "sx">) => {
  const value = castArray(valueProp);
  return (
    <Autocomplete
      data-testid={testIds.goodsInputAutocomplete}
      disablePortal
      multiple
      options={goodInventoryItems || []}
      getOptionLabel={(goodInventoryItem) => goodInventoryItem.label}
      renderOption={(props, goodInventoryItem) => (
        <li
          {...props}
          data-testid={testIds.goodsInputAutocompleteOption}
          data-value={goodInventoryItem.label}
        >
          {goodInventoryItem.label}
        </li>
      )}
      onChange={(event, value) => {
        if (!value) {
          return;
        }
        onChange(value.map((o) => o.label));
      }}
      value={
        goodInventoryItems.filter((goodItem) =>
          value.includes(goodItem.label)
        ) || null
      }
      size="small"
      renderInput={(inputProps) => (
        <TextField
          {...inputProps}
          label={otherProps.label}
          inputProps={{
            ...inputProps.inputProps,
            "data-testid": testIds.goodsInputAutocompleteInput,
          }}
        />
      )}
      sx={{
        display: "flex",
      }}
      {...otherProps}
    />
  );
};

export default GoodsInput;
